var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVDepression = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsx("g", __assign({ clipPath: "url(.clip0_12_2142)" }, { children: _jsx("path", { d: "M6 2a3 3 0 0 0-3 3v1.035A3.5 3.5 0 0 0 0 9.5v5.486a.996.996 0 0 0 .632.944l11.334 4.796a5.116 5.116 0 0 0 4.071-.037l1.48-.657a.994.994 0 0 1 1.172.278c1.782 2.178 5.311.918 5.311-1.895V9.5a3.5 3.5 0 0 0-3-3.465V5a3 3 0 0 0-3-3h-4c-.768 0-1.47.289-2 .764A2.989 2.989 0 0 0 10 2H6Zm-1 8v4H2V9.5a1.5 1.5 0 1 1 3 0v.5Zm12 1v3H7v-3h10Zm5-1.5V14h-3V9.5a1.5 1.5 0 0 1 3 0Zm-3-3.163A3.504 3.504 0 0 0 17.035 9H13V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1.337ZM11 5v4H6.965A3.504 3.504 0 0 0 5 6.337V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Z", fill: "currentColor" }) }))] })));
};
export default SvgVDepression;
